import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import './App.css';
import AppHeader from './components/AppHeader';
import UebersichtTransaktionen from './components/UebersichtTransaktionen';
import TransaktionDetails from './components/TransaktionDetails';
import TransaktionAnlegen from './components/TransaktionAnlegen';
import AuditLog from './components/AuditLog';
import XmlImport from './components/XmlImport';
import LandingPage from './components/LandingPage';
import Datenschutz from './components/Datenschutz';
import Impressum from './components/Impressum';
import UeberRefiReg from './components/UeberRefiReg';
import Anwendungsfaelle from './components/Anwendungsfaelle';
import { useAuth } from 'react-oidc-context';
import { setAuthContext } from './services/apiService';

function App() {
  const auth = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    console.log('Auth status changed:', { 
      isLoading: auth.isLoading, 
      isAuthenticated: auth.isAuthenticated, 
      hasToken: !!auth.user?.access_token,
      error: auth.error,
      user: auth.user ? { profile: auth.user.profile, expired: auth.user.expired } : null
    });
    if (auth.isAuthenticated && auth.user?.access_token) {
      console.log('Setting auth context in apiService');
      setAuthContext(auth);
    }
  }, [auth]);

  if (auth.isLoading) {
    return <div className="loading-container">Lade Authentifizierung...</div>;
  }

  if (auth.error) {
    return <div className="error-container">Authentifizierungsfehler: {auth.error.message}</div>;
  }

  if (!auth.isAuthenticated) {
    return (
      <Routes>
        <Route path="/datenschutz" element={<Datenschutz onBack={() => navigate('/')} />} />
        <Route path="/impressum" element={<Impressum onBack={() => navigate('/')} />} />
        <Route path="/ueber-refireg" element={<UeberRefiReg onBack={() => navigate('/')} />} />
        <Route path="/anwendungsfaelle" element={<Anwendungsfaelle onBack={() => navigate('/')} />} />
        <Route
          path="/"
          element={
            <LandingPage
              onLogin={() => auth.signinRedirect()}
              onDatenschutz={() => navigate('/datenschutz')}
              onImpressum={() => navigate('/impressum')}
              onUeberRefiReg={() => navigate('/ueber-refireg')}
              onAnwendungsfaelle={() => navigate('/anwendungsfaelle')}
            />
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    );
  }

  const handleMenuAction = (action) => {
    switch(action) {
      case 'overview':
        navigate('/transaktionen');
        break;
      case 'create-transaction':
        navigate('/transaktionen/neu');
        break;
      case 'xml-import':
        navigate('/xml-import');
        break;
      case 'audit-log':
        navigate('/audit-log');
        break;
      case 'logout':
        auth.signoutRedirect();
        break;
      default:
        break;
    }
  };

  return (
    <div className="refireg-app-container">
      <AppHeader onMenuAction={handleMenuAction} user={auth.user} />
      <Routes>
        <Route path="/" element={<Navigate to="/transaktionen" replace />} />
        <Route
          path="/transaktionen"
          element={<UebersichtTransaktionen onSelect={entry => navigate(`/transaktionen/${entry.id}`)} />}
        />
        <Route
          path="/transaktionen/:id"
          element={<TransaktionDetails onBack={() => navigate('/transaktionen')} />}
        />
        <Route path="/transaktionen/neu" element={<TransaktionAnlegen />} />
        <Route path="/xml-import" element={<XmlImport />} />
        <Route path="/audit-log" element={<AuditLog />} />
        <Route path="*" element={<Navigate to="/transaktionen" replace />} />
      </Routes>
    </div>
  );
}

export default App;
